import React from "react";
import desktopImg from "../assests/desktop.png";
import mobileImg from "../assests/telefon.png";

const TopBanner = ({ alt = "Banner", className = "" }) => {
  return (
    <picture>
      {/* Mobil */}
      <source media="(max-width: 768px)" srcSet={mobileImg} />

      {/* Desktop */}
      <img src={desktopImg} alt={alt} className={className} />
    </picture>
  );
};

export default TopBanner;